import isEmpty from 'lodash/isEmpty'

const required = { required: true, message: 'This is a required field' }
const requiredRule = [required]

const nonEmptySelectRule = [
  {
    validator: (_: any, val: string[]) => {
      return isEmpty(val)
        ? Promise.reject('Please select at least one store')
        : Promise.resolve()
    }
  }
]

export { requiredRule, nonEmptySelectRule }
